import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bf-sidebar__logo" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "bf-sidebar__nav" }
const _hoisted_4 = {
  key: 0,
  class: "bf-nav-sub"
}
const _hoisted_5 = {
  key: 1,
  class: "bf-nav-sub"
}
const _hoisted_6 = { class: "bf-sidebar__footer" }
const _hoisted_7 = { class: "bf-user" }
const _hoisted_8 = { class: "bf-user__avatar" }
const _hoisted_9 = { class: "bf-user__info" }
const _hoisted_10 = { class: "bf-user__name" }
const _hoisted_11 = { class: "bf-user__role" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(['bf-sidebar', { open: _ctx.stateStoreInstance.open }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "d-flex align-center"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.logoSrc,
            alt: "Bindfy"
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("nav", _hoisted_3, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "bf-sidebar__label" }, "MENU", -1)),
      _createVNode(_component_router_link, {
        to: "/",
        class: "bf-nav-item",
        "exact-active-class": "is-active"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("rect", {
              x: "3",
              y: "3",
              width: "7",
              height: "9",
              rx: "1.5"
            }),
            _createElementVNode("rect", {
              x: "14",
              y: "3",
              width: "7",
              height: "5",
              rx: "1.5"
            }),
            _createElementVNode("rect", {
              x: "14",
              y: "12",
              width: "7",
              height: "9",
              rx: "1.5"
            }),
            _createElementVNode("rect", {
              x: "3",
              y: "16",
              width: "7",
              height: "5",
              rx: "1.5"
            })
          ], -1),
          _createTextVNode(" Dashboard ", -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["bf-nav-item", { 'is-open': _ctx.openConnectors }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglConnectors && _ctx.togglConnectors(...args)))
      }, [...(_cache[5] || (_cache[5] = [
        _createStaticVNode("<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" data-v-332071f4><path d=\"M9 6h11M9 12h11M9 18h11\" data-v-332071f4></path><circle cx=\"4.5\" cy=\"6\" r=\"1.6\" data-v-332071f4></circle><circle cx=\"4.5\" cy=\"12\" r=\"1.6\" data-v-332071f4></circle><circle cx=\"4.5\" cy=\"18\" r=\"1.6\" data-v-332071f4></circle></svg> Conectores <svg class=\"bf-nav-item__caret\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-332071f4><path d=\"M6 9l6 6 6-6\" data-v-332071f4></path></svg>", 3)
      ]))], 2),
      (_ctx.openConnectors)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/conectores/entrada",
              class: "bf-nav-subitem",
              "active-class": "is-active"
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("Entrada", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/conectores/saida",
              class: "bf-nav-subitem",
              "active-class": "is-active"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("Saída", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: "/queries",
        class: "bf-nav-item",
        "active-class": "is-active"
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "M4 17l6-6-6-6" }),
            _createElementVNode("path", { d: "M12 19h8" })
          ], -1),
          _createTextVNode(" Queries ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/integracoes",
        class: "bf-nav-item",
        "active-class": "is-active"
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("circle", {
              cx: "5",
              cy: "12",
              r: "2.5"
            }),
            _createElementVNode("circle", {
              cx: "19",
              cy: "5",
              r: "2.5"
            }),
            _createElementVNode("circle", {
              cx: "19",
              cy: "19",
              r: "2.5"
            }),
            _createElementVNode("path", { d: "M7.3 10.8L16.7 6.2M7.3 13.2l9.4 4.6" })
          ], -1),
          _createTextVNode(" Integrações ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/execucoes",
        class: "bf-nav-item",
        "active-class": "is-active"
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "9"
            }),
            _createElementVNode("path", { d: "M12 7v5l3.5 2" })
          ], -1),
          _createTextVNode(" Histórico ", -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["bf-nav-item", { 'is-open': _ctx.openPayments }]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglPayments && _ctx.togglPayments(...args)))
      }, [...(_cache[11] || (_cache[11] = [
        _createStaticVNode("<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-332071f4><rect x=\"2.5\" y=\"5\" width=\"19\" height=\"14\" rx=\"2.5\" data-v-332071f4></rect><path d=\"M2.5 10h19\" data-v-332071f4></path></svg> Pagamentos <svg class=\"bf-nav-item__caret\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-332071f4><path d=\"M6 9l6 6 6-6\" data-v-332071f4></path></svg>", 3)
      ]))], 2),
      (_ctx.openPayments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/pagamentos/assinaturas",
              class: "bf-nav-subitem",
              "active-class": "is-active"
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("Assinatura", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/pagamentos/historico",
              class: "bf-nav-subitem",
              "active-class": "is-active"
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("Histórico de faturas", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_link, {
        to: "/usuarios",
        class: "bf-nav-item",
        "active-class": "is-active"
      }, {
        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "8",
              r: "4"
            }),
            _createElementVNode("path", { d: "M4.5 20.5c1.5-3.5 4.2-5 7.5-5s6 1.5 7.5 5" })
          ], -1),
          _createTextVNode(" Usuários ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/configuracoes/notificacoes",
        class: "bf-nav-item",
        "active-class": "is-active"
      }, {
        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" }),
            _createElementVNode("path", { d: "M13.73 21a2 2 0 0 1-3.46 0" })
          ], -1),
          _createTextVNode(" Notificações ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/ticket",
        class: "bf-nav-item",
        "active-class": "is-active"
      }, {
        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
          _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("circle", {
              cx: "12",
              cy: "12",
              r: "9"
            }),
            _createElementVNode("path", { d: "M9.2 9a2.8 2.8 0 1 1 3.6 2.7c-.7.3-.8.8-.8 1.8" }),
            _createElementVNode("circle", {
              cx: "12",
              cy: "17",
              r: ".5",
              fill: "currentColor"
            })
          ], -1),
          _createTextVNode(" Suporte ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "bf-theme-toggle",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args)))
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.isDark ? "Modo escuro" : "Modo claro"), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["bf-switch", { on: _ctx.isDark }])
        }, [...(_cache[18] || (_cache[18] = [
          _createElementVNode("div", { class: "bf-switch__knob" }, null, -1)
        ]))], 2)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.userInitials), 1),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.userName), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.userRole), 1)
        ]),
        (_openBlock(), _createElementBlock("svg", {
          class: "bf-user__logout",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          title: "Sair"
        }, [...(_cache[19] || (_cache[19] = [
          _createElementVNode("path", { d: "M15 4h4v16h-4M10 17l5-5-5-5M15 12H3" }, null, -1)
        ]))]))
      ])
    ])
  ], 2))
}